var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app flex-row align-items-center"},[(_vm.sportProvider == 0)?_c('HistoryDigi'):_vm._e(),(_vm.sportProvider == 3)?_c('SportsbookMaintenance'):_vm._e(),(_vm.sportProvider == 1)?_c('HistoryBetco'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }